export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./temporary-password-reset.vue?vue&type=template&id=8c897ab8"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/temporary-password-reset/temporary-password-reset.vue?vue&type=template&id=8c897ab8
// module id = tobx
// module chunks = 0